
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import ChatFace from '../ChatFace/index.vue';
const MAX_SHOW_TOOL_BTN_COUNT = 6;

interface ShowBtns {
  isShow: boolean;
  name: string;
  icon: string;
  enable: boolean;
}

@Component({
  name: 'BtnTools',
  components: {
    ChatFace,
  },
})
class BtnTools extends Vue {
  @Inject('inIframe') inIframe:boolean|undefined;
  @Inject('globalData') globalData: any;
  @Prop({
    default: [],
  }) toolButtons: any;

  qqFaceShow = false;
  permissionPopup:any = null;

  showPop = false;
  items: ShowBtns[] = [];
  showBtns:ShowBtns[] = [];

  @Watch('toolBtns', { immediate: true, deep: true })
  onToolBtnsChange(btns) {
    const showBtn = btns.filter(item => item.isShow);

    this.items = showBtn.slice(MAX_SHOW_TOOL_BTN_COUNT);
    if (this.showMore) {
      this.showBtns =  showBtn.slice(0, MAX_SHOW_TOOL_BTN_COUNT);
    } else {
      this.showBtns = showBtn;
    }
  }

  /**
   * IM基础功能按钮。
   * 注意：fixedAction 类按钮不受排序影响。
   * 注意，PC平台中，所有按钮均可参与排序。
   */
  get toolBtns() {
    const defaultActions = [
      // 发送表情
      {
        actionType: 'sendFace',
        icon: require('../assets/face.svg'),
        name: this.$t('common_insert_emoji_text'),
      },
      // 发送图片
      {
        actionType: 'sendImageMessage',
        icon: require('../assets/img-upload.svg'),
        name: this.$t('common_insert_photo_text'),
      },
      // 发送文件
      {
        actionType: 'sendFileMessage',
        icon: require('../assets/file-upload.svg'),
        name: this.$t('common_insert_file_text'),
      },
      // 满意度评价
      {
        actionType: 'activeFeedback',
        // 后期需要补充图标
        icon: require('../assets/feed-back.svg'),
        name: this.$t('common_feed_back_text'),
      },
      // 机器人转人工
      {
        actionType: 'robotTransfer',
        // 后期需要补充图标
        icon: require('../assets/audo.svg'),
        name: this.$t('common_insert_audo_text'),
      },
      // 结束会话
      {
        actionType: 'closeSession',
        icon: require('../assets/quite.svg'),
        name: this.$t('common_manual_close_text'),
      },
      // 退出排队
      {
        actionType: 'exitQueue',
        icon: require('../assets/quite.svg'),
        name: this.$t('exit_queque_btn'),
      },
    ];
    const toolBtns = this.toolButtons.map((item) => {
      const { actionType } = item;
      // 如果是内置功能按钮，就处理一下icon, name, title
      const innerActionBtn = defaultActions.find(sub => sub.actionType === actionType);
      if (actionType && innerActionBtn) {
        Object.assign(item, innerActionBtn, item);
      }
      return item;
    });
    // 过滤掉固定功能按钮，如表情，语音发送
    return toolBtns.filter(item => !item.fixedAction);
  }

  get showMore() {
    return this.items.length > 0 && this.inIframe;
  }

  // 是否可以发送图片
  get canSendImage() {
    const conf = this.toolButtons.find(item => item.actionType === 'sendImageMessage');
    const { isShow, enable } = conf || {};
    return isShow && enable;
  }
  /**
   * 功能按钮点击
   * @param item
   */
  clickToolBtn(item) {
    const { actionType, enable } = item;
    // PC 有 enable逻辑
    if (!enable) {
      return;
    }

    if (actionType && typeof (this[actionType]) === 'function') {
      this[actionType]();
    } else {
      this.$emit('clickToolBtn', item);
    }
  }

  /**
   * 发送图片消息
   */
  sendImageMessage() {
    return this.openFileUpload('image');
  }

  /**
   * 发送文件消息
   */
  sendFileMessage() {
    return this.openFileUpload('file');
  }

  openFileUpload(type: string) {
    this.requirePermission(type, () => {
      this.$emit('openFileUpload', type);
    });
  }
  sendFace() {
    this.qqFaceShow = !this.qqFaceShow;
  }
  watchDocumentClick() {
    if (this.qqFaceShow) {
      this.qqFaceShow = false;
    }
    if (this.showPop) {
      this.showPop = false;
    }
  }

  clickFaceItem(title:string) {
    this.$emit('clickFaceItem', title);
  }
  mounted() {
    document.addEventListener('click', this.watchDocumentClick);
  }

  beforeDestory() {
    document.removeEventListener('click', this.watchDocumentClick);
  }

  robotTransfer() {
    this.$emit('robotTransfer');
  }

  closeSession() {
    this.$emit('closeSession');
  }

  /**
   * 退出排队
   */
  exitQueue() {
    this.$emit('exitQueue');
  }

  activeFeedback() {
    this.$emit('activeFeedback');
  }

  /**
     * 文件、图片授权
     */
  requirePermission(type, onSuccess: Function, onFail?: Function) {
    // 获得图片、文件发送授权Tip
    const actionList = { image: 'sendImageMessage', file: 'sendFileMessage' };
    const conf = this.toolButtons.find(item => item.actionType === actionList[type]);
    const { authorizeTip } = conf || {};

    // 当前约定逻辑：存储在变量中，刷新后清除
    if (!authorizeTip || this.permissionPopup) {
      onSuccess && onSuccess();
      return;
    }

    this.$Confirm({
      title: `${authorizeTip.title.replace(/\s/g, '&nbsp;') || this.$t('sysmsg_upload_file_permission_require_msg')}`,
      text: `${authorizeTip.explain.replace(/\s/g, '&nbsp;')}`,
      confirmText: this.$t('common_allow_text'),
      cancelText: this.$t('common_not_allow_text'),
    }).then(() => {
      this.permissionPopup = 1;
      onSuccess && onSuccess();
    })
      .catch(() => {
        onFail && onFail();
      });
  }
}
export default BtnTools;
